import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginUser } from "./authAPI";
import { registerUser } from "./authAPI";

export const registerUserAsync = createAsyncThunk(
  "auth/registerUser",
  async (data, { rejectWithValue }) => {
    try {
      console.log("API calling with:", data);
      const response = await registerUser(data);
      console.log("API response:", response); 
      return response.data;
    } catch (error) {
      console.log("API error:", error); 
      return rejectWithValue(error.message);
    }
  }
);


export const loginUserAsync = createAsyncThunk(
  "auth/loginUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await loginUser(data);
      if (!response.data.length) {
        return rejectWithValue("Invalid credentials"); 
      }
      return response.data;

    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: (() => {
    try {
      const item = localStorage.getItem("user");
      return item && item !== "undefined" ? JSON.parse(item) : null;
    } catch {
      return null;
    }
  })(),
  loading: false,
  error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      localStorage.removeItem("user");
    },
  },
  extraReducers: (builder) => {
    builder
    // Login
      .addCase(loginUserAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUserAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload[0];
        localStorage.setItem("user", JSON.stringify(action.payload[0]));
      })
      .addCase(loginUserAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    // REGISTER
    .addCase(registerUserAsync.pending, (state) => {
      state.loading = true;
    })
    .addCase(registerUserAsync.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload; // auto login after register
        localStorage.setItem("user", JSON.stringify(action.payload));

    })
    .addCase(registerUserAsync.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;